import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/static/onboarding/astronaut.png'


const _withScopeId = n => (_pushScopeId("data-v-4fd00699"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message" }
const _hoisted_2 = { class: "message__box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: /*#__PURE__*/_normalizeClass(['astronaut', 'floating']),
  src: _imports_0,
  alt: "Astronauta"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.closeMessage()), ["prevent"]))
      }, "Ok, entendi")
    ])
  ]))
}